(function () {
    'use strict';

    var CACHE_PREFIX = 'bv-product-qa:v2:';
    var CACHE_TTL_MS = 30 * 60 * 1000;

    function getCacheKey(apiBaseUrl, upc) {
        return CACHE_PREFIX + apiBaseUrl + ':' + upc;
    }

    function hasCachedQuestions(data) {
        return (data.products || []).some(function (product) {
            return product.questions && product.questions.length;
        });
    }

    function escapeHtml(value) {
        if (value == null) return '';
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function parseDate(isoDate) {
        if (!isoDate) return null;
        var date = new Date(String(isoDate).replace(' ', 'T'));
        return Number.isNaN(date.getTime()) ? null : date;
    }

    function formatRelativeDate(isoDate) {
        var date = parseDate(isoDate);
        if (!date) return '';

        var diffMs = Date.now() - date.getTime();
        var days = Math.floor(diffMs / 86400000);

        if (days < 1) return 'today';
        if (days === 1) return '1 day ago';
        if (days < 30) return days + ' days ago';

        var months = Math.floor(days / 30);
        if (months === 1) return 'a month ago';
        if (months < 12) return months + ' months ago';

        var years = Math.floor(months / 12);
        return years === 1 ? 'a year ago' : years + ' years ago';
    }

    function getCurrentVariantId() {
        var urlId = new URLSearchParams(window.location.search).get('variant');
        if (urlId) return urlId;

        var input = document.querySelector(
            '.product-details-page input[name="id"], .product-details-page select[name="id"]',
        );
        if (input && input.value) return input.value;

        if (window.ProductState && window.ProductState.defaultVariantId) {
            return window.ProductState.defaultVariantId;
        }

        return null;
    }

    function getVariantBarcode(variantId) {
        if (!variantId || !window.ProductState || !Array.isArray(window.ProductState.variants)) {
            return null;
        }

        var variant = window.ProductState.variants.find(function (item) {
            return String(item.id) === String(variantId);
        });

        if (!variant || !variant.barcode) return null;

        var barcode = String(variant.barcode).trim();
        return barcode || null;
    }

    function readCache(apiBaseUrl, upc) {
        try {
            var raw = sessionStorage.getItem(getCacheKey(apiBaseUrl, upc));
            if (!raw) return null;

            var parsed = JSON.parse(raw);
            if (!parsed || !parsed.fetchedAt || !parsed.data) return null;
            if (Date.now() - parsed.fetchedAt > CACHE_TTL_MS) {
                sessionStorage.removeItem(getCacheKey(apiBaseUrl, upc));
                return null;
            }

            if (!hasCachedQuestions(parsed.data)) {
                sessionStorage.removeItem(getCacheKey(apiBaseUrl, upc));
                return null;
            }

            return parsed.data;
        } catch (error) {
            return null;
        }
    }

    function writeCache(apiBaseUrl, upc, data) {
        if (!hasCachedQuestions(data)) return;

        try {
            sessionStorage.setItem(
                getCacheKey(apiBaseUrl, upc),
                JSON.stringify({
                    fetchedAt: Date.now(),
                    data: data,
                }),
            );
        } catch (error) {
            // Ignore quota errors.
        }
    }

    function flattenQuestions(products) {
        var seen = {};
        var merged = [];

        (products || []).forEach(function (product) {
            (product.questions || []).forEach(function (question) {
                var key = String(question.id);
                if (seen[key]) return;
                seen[key] = true;
                merged.push(
                    Object.assign({}, question, {
                        sourceProductName: product.name || '',
                    }),
                );
            });
        });

        merged.sort(function (a, b) {
            var aDate = parseDate(a.firstModeratedDate);
            var bDate = parseDate(b.firstModeratedDate);
            return (bDate ? bDate.getTime() : 0) - (aDate ? aDate.getTime() : 0);
        });

        return merged;
    }

    function normalizeQuestionText(value) {
        if (value == null) return '';
        return String(value)
            .replace(/[\r\n]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function getQuestionDisplayText(question) {
        var title = normalizeQuestionText(question.title);
        if (title) return title;

        return normalizeQuestionText(question.text);
    }

    function sortAnswers(answers) {
        return (answers || []).slice().sort(function (a, b) {
            if (a.answeredByBrand !== b.answeredByBrand) {
                return a.answeredByBrand ? -1 : 1;
            }

            var aDate = parseDate(a.submissionDate);
            var bDate = parseDate(b.submissionDate);
            return (bDate ? bDate.getTime() : 0) - (aDate ? aDate.getTime() : 0);
        });
    }

    function buildAnswerHtml(answer, question) {
        var author = escapeHtml(answer.answererDisplayName || 'Anonymous');
        var date = formatRelativeDate(answer.submissionDate);
        var authorDisabled = answer.answeredByBrand ? ' disabled=""' : '';

        return (
            '<li>' +
            '<div class="bv-qna__sc-1jzdgqe-3 bWCmqX">' +
            '<div class="bv-qna__sc-1jzdgqe-2 bzJWvW">' +
            '<div tabindex="-1" id="bv-api-answer-content-' +
            escapeHtml(answer.id) +
            '" class="bv-qna__sc-1jzdgqe-1 eUVFMF"><b>A:</b> ' +
            escapeHtml(answer.text || '') +
            '</div>' +
            '<button type="button" aria-label="See ' +
            author +
            ' profile."' +
            authorDisabled +
            ' class="bv-qna__sc-2a9khn-4 eeRrrR">' +
            author +
            '</button>' +
            '<small class="bv-qna__sc-2a9khn-5 eEPqTC">' +
            escapeHtml(date) +
            '</small>' +
            '</div>' +
            '</div>' +
            '</li>'
        );
    }

    function buildQuestionHtml(question, hidden) {
        var questionTitle = escapeHtml(getQuestionDisplayText(question)).replace(/^Q:\s*/i, '');
        var asker = escapeHtml(question.askerDisplayName || 'Anonymous');
        var askedOn = formatRelativeDate(question.firstModeratedDate);
        var answers = sortAnswers(question.answers);
        var answerCount = answers.length;
        var answerCountLabel = answerCount === 1 ? '1  Answer' : answerCount + '  Answers';
        var answerLabel =
            answerCount +
            ' Answers to Question: ' +
            escapeHtml(getQuestionDisplayText(question)).replace(/^Q:\s*/i, '') +
            '.';

        var originallyPosted = question.sourceProductName
            ? '<div class="bv-qna__sc-1gblln8-0 fkMBOC">' +
              '<div class="bv-qna__sc-1gblln8-1 geglNw">' +
              '<div class="bv-qna__sc-1gblln8-3 iWqxHg">' +
              '<div>Originally posted on ' +
              escapeHtml(question.sourceProductName) +
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>'
            : '';

        var answersHtml = answers
            .map(function (answer) {
                return buildAnswerHtml(answer, question);
            })
            .join('');

        return (
            '<div id="bv-api-question-container-' +
            escapeHtml(question.id) +
            '" class="bv-qna__sc-13ebvvl-2 fNiXLI' +
            (hidden ? ' bv-api-qa__item--hidden' : '') +
            '"' +
            (hidden ? ' hidden' : '') +
            '>' +
            '<div class="bv-qna__sc-13ebvvl-4 jPzwnt">' +
            '<h3 tabindex="-1" id="bv-api-question-label-' +
            escapeHtml(question.id) +
            '" class="bv-qna__sc-13ebvvl-0 ixbLdd"> Q: ' +
            questionTitle +
            '</h3>' +
            '<button type="button" aria-label="See ' +
            asker +
            ' profile." tabindex="0" class="bv-qna__sc-2a9khn-4 eeRrrR">' +
            asker +
            '</button>' +
            '<small class="bv-qna__sc-2a9khn-5 eEPqTC">' +
            escapeHtml(askedOn) +
            '</small>' +
            '</div>' +
            originallyPosted +
            '<div class="bv-qna__sc-13ebvvl-3 cYBkfz">' +
            '<small class="bv-qna__sc-2a9khn-5 bv-qna__sc-13ebvvl-1 eEPqTC LCBDQ">' +
            answerCountLabel +
            '</small>' +
            '</div>' +
            (answerCount
                ? '<section class="bv-qna__sc-199foez-1 gBVqWq" aria-label="' +
                  escapeHtml(answerLabel) +
                  '">' +
                  '<ul class="bv-qna__sc-199foez-2 iDVDtr">' +
                  answersHtml +
                  '</ul>' +
                  '</section>'
                : '') +
            '</div>'
        );
    }

    function buildQuestionsHtml(questions, maxVisible) {
        if (!questions.length) return '';

        var html = '<div class="bv-qna__sc-2a9khn-1 gYyWGA">';

        questions.forEach(function (question, index) {
            html += buildQuestionHtml(question, index >= maxVisible);
        });

        html += '</div>';

        if (questions.length > maxVisible) {
            html +=
                '<button type="button" class="bv-qna__stck7e-0 iagRQY" data-bv-qa-show-more>Show more questions (' +
                (questions.length - maxVisible) +
                ')</button>';
        }

        return html;
    }

    function setStatus(root, message, type) {
        var status = root.querySelector('[data-bv-qa-status]');
        if (!status) return;

        status.textContent = message || '';
        status.classList.remove('bv-api-qa__status--loading', 'bv-api-qa__status--error', 'bv-api-qa__status--empty');

        if (type) {
            status.classList.add('bv-api-qa__status--' + type);
        }

        status.hidden = !message;
    }

    function setCount(root, count, visible) {
        var countEl = root.querySelector('[data-bv-qa-count]');
        if (!countEl) return;
        countEl.hidden = true;
        countEl.textContent = '';
    }

    function setVisibility(root, visible) {
        if (visible) {
            root.hidden = false;
            root.removeAttribute('hidden');
        } else {
            root.hidden = true;
            root.setAttribute('hidden', 'hidden');
        }
    }

    function refreshAccordionHeight(root) {
        var collapse = root.closest('.collapse');
        if (!collapse || !collapse.classList.contains('show') || collapse._accordionAnimating) return;

        // Keep open panels on auto height so late-loading BV/API content can expand.
        collapse.style.height = 'auto';
        collapse.style.overflow = '';
    }

    function observeAccordionContent(root) {
        var collapse = root.closest('.collapse');
        if (!collapse || collapse.dataset.bvQaResizeBound === 'true') return;
        collapse.dataset.bvQaResizeBound = 'true';

        if (typeof ResizeObserver === 'undefined') return;

        var observer = new ResizeObserver(function () {
            refreshAccordionHeight(root);
        });
        observer.observe(collapse);
    }

    function bindShowMore(root) {
        var button = root.querySelector('[data-bv-qa-show-more]');
        if (!button || button.dataset.bound === 'true') return;

        button.dataset.bound = 'true';
        button.addEventListener('click', function () {
            var items = root.querySelectorAll('.bv-api-qa__item--hidden');
            items.forEach(function (item) {
                item.hidden = false;
            });

            button.hidden = true;
        });
    }

    function normalizeApiBaseUrl(value) {
        var url = String(value || '').trim().replace(/\/$/, '');
        if (!url) return '';
        if (!/^https?:\/\//i.test(url)) {
            url = 'https://' + url;
        }
        return url;
    }

    function ProductQuestionsAnswers(root) {
        this.root = root;
        this.embedded = root.dataset.embedded === 'true';
        this.sectionId = root.dataset.sectionId;
        this.apiBaseUrl = normalizeApiBaseUrl(root.dataset.apiBaseUrl);
        this.maxVisible = parseInt(root.dataset.maxQuestions, 10) || 5;
        this.brandBadgeText = root.dataset.brandBadgeText || 'Answered by VIGO';
        this.emptyMessage = root.dataset.emptyMessage || 'No questions yet for this product.';
        this.noBarcodeMessage =
            root.dataset.noBarcodeMessage || 'No product identifier available to load questions.';
        this.errorMessage =
            root.dataset.errorMessage || 'Unable to load questions right now. Please try again later.';
        this.currentUpc = null;
        this.fetchController = null;
        this.variantListenerBound = false;
    }

    ProductQuestionsAnswers.prototype.disableApi = function () {
        var content = this.root.querySelector('[data-bv-qa-content]');
        if (content) content.innerHTML = '';

        setCount(this.root, 0);
        setStatus(this.root, '', null);
        setVisibility(this.root, false);
        this.root.setAttribute('aria-busy', 'false');
        this.root.removeAttribute('data-bv-qa-loaded');
    };

    ProductQuestionsAnswers.prototype.handleEmptyState = function (message, type) {
        var content = this.root.querySelector('[data-bv-qa-content]');
        if (content) content.innerHTML = '';

        setCount(this.root, 0);
        this.root.setAttribute('aria-busy', 'false');
        this.root.removeAttribute('data-bv-qa-loaded');

        // When embedded under the BV app block, hide empty API results so only BV shows.
        if (this.embedded && type !== 'error') {
            setStatus(this.root, '', null);
            setVisibility(this.root, false);
            refreshAccordionHeight(this.root);
            return;
        }

        setVisibility(this.root, true);
        setStatus(this.root, message, type);
        refreshAccordionHeight(this.root);
    };

    ProductQuestionsAnswers.prototype.renderQuestions = function (questions) {
        var content = this.root.querySelector('[data-bv-qa-content]');
        if (!content) return;

        if (!questions.length) {
            this.handleEmptyState(this.emptyMessage, 'empty');
            return;
        }

        setVisibility(this.root, true);
        content.innerHTML = buildQuestionsHtml(questions, this.maxVisible);

        setCount(this.root, questions.length, Math.min(this.maxVisible, questions.length));
        setStatus(this.root, '', null);
        this.root.setAttribute('aria-busy', 'false');
        bindShowMore(this.root);
        refreshAccordionHeight(this.root);
    };

    ProductQuestionsAnswers.prototype.fetchQuestions = function (upc) {
        var self = this;

        if (!upc) {
            this.currentUpc = null;
            this.handleEmptyState(this.noBarcodeMessage, 'empty');
            return;
        }

        if (this.currentUpc === upc && this.root.getAttribute('data-bv-qa-loaded') === 'true') {
            return;
        }

        this.currentUpc = upc;
        this.root.setAttribute('aria-busy', 'true');
        this.root.removeAttribute('data-bv-qa-loaded');
        setCount(this.root, 0);

        // Keep the accordion panel measurable while the API is in flight.
        // Hiding during load made early clicks open a 0-height panel.
        setVisibility(this.root, true);
        setStatus(this.root, 'Loading questions...', 'loading');
        refreshAccordionHeight(this.root);

        var cached = readCache(this.apiBaseUrl, upc);
        if (cached) {
            this.renderQuestions(flattenQuestions(cached.products || []));
            this.root.setAttribute('data-bv-qa-loaded', 'true');
            return;
        }

        if (!this.apiBaseUrl) {
            this.disableApi();
            return;
        }

        if (this.fetchController) {
            this.fetchController.abort();
        }

        this.fetchController = new AbortController();

        fetch(this.apiBaseUrl + '/products/' + encodeURIComponent(upc) + '/questions', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            signal: this.fetchController.signal,
        })
            .then(function (response) {
                if (response.status === 404) {
                    return { found: false, products: [] };
                }

                if (!response.ok) {
                    throw new Error('Request failed with status ' + response.status);
                }

                return response.json();
            })
            .then(function (data) {
                writeCache(self.apiBaseUrl, upc, data);
                var questions = flattenQuestions(data.products || []);
                self.renderQuestions(questions);
                self.root.setAttribute('data-bv-qa-loaded', 'true');
            })
            .catch(function (error) {
                if (error && error.name === 'AbortError') return;
                console.error('[BV API Q&A] Fetch failed for UPC', upc, error);
                self.disableApi();
            });
    };

    ProductQuestionsAnswers.prototype.loadForCurrentVariant = function () {
        var variantId = getCurrentVariantId();
        var upc = getVariantBarcode(variantId);
        this.fetchQuestions(upc);
    };

    ProductQuestionsAnswers.prototype.bindVariantListeners = function () {
        var self = this;

        if (this.variantListenerBound) return;
        this.variantListenerBound = true;

        var productRoot = document.querySelector('.product-details-page');
        if (productRoot) {
            productRoot.addEventListener('change', function () {
                window.setTimeout(function () {
                    self.loadForCurrentVariant();
                }, 0);
            });

            productRoot.addEventListener('input', function (event) {
                if (!event.target.closest('.swatch-element, .single-option-selector')) return;
                window.setTimeout(function () {
                    self.loadForCurrentVariant();
                }, 0);
            });
        }

        window.addEventListener('popstate', function () {
            self.loadForCurrentVariant();
        });

        if (!window.__bvQaHistoryPatched) {
            window.__bvQaHistoryPatched = true;

            ['pushState', 'replaceState'].forEach(function (methodName) {
                var original = history[methodName];
                history[methodName] = function () {
                    var result = original.apply(this, arguments);
                    window.dispatchEvent(new Event('vigo:historychange'));
                    return result;
                };
            });
        }

        window.addEventListener('vigo:historychange', function () {
            self.loadForCurrentVariant();
        });
    };

    ProductQuestionsAnswers.prototype.bindAccordionListener = function () {
        var self = this;
        var tab = this.root.closest('.tab');
        if (!tab || tab.dataset.bvQaAccordionBound === 'true') return;

        tab.dataset.bvQaAccordionBound = 'true';

        var trigger = tab.querySelector('a.tab-title[href^="#"]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
            var collapse = self.root.closest('.collapse');
            var willExpand = collapse && !collapse.classList.contains('show');

            if (willExpand && self.root.getAttribute('aria-busy') === 'true') {
                setVisibility(self.root, true);
                setStatus(self.root, 'Loading questions...', 'loading');
            }

            window.setTimeout(function () {
                if (willExpand) {
                    refreshAccordionHeight(self.root);
                }

                if (self.root.getAttribute('data-bv-qa-loaded') !== 'true') {
                    self.loadForCurrentVariant();
                }
            }, 50);

            // Content often arrives after the open animation; refresh again then.
            window.setTimeout(function () {
                refreshAccordionHeight(self.root);
            }, 400);
        });
    };

    ProductQuestionsAnswers.prototype.init = function () {
        if (!this.apiBaseUrl) {
            this.disableApi();
            return;
        }

        this.bindVariantListeners();
        this.bindAccordionListener();
        observeAccordionContent(this.root);
        this.loadForCurrentVariant();
    };

    function initSection(root) {
        if (!root || root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        var instance = new ProductQuestionsAnswers(root);
        instance.init();
    }

    function initAllSections(scope) {
        var root = scope || document;
        root.querySelectorAll('[data-bv-product-qa]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAllSections();
        });
    } else {
        initAllSections();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target;
        if (!section) return;

        section.querySelectorAll('[data-bv-product-qa]').forEach(function (qaRoot) {
            qaRoot.dataset.initialized = 'false';
        });

        initAllSections(section);
    });
})();
